// import React from 'react';
// import './About.css';

// const About = () => {
//   return (
//     <div className="about-us-container">
//       <h1 className="about-us-title">About Us</h1>
//       <p className="about-us-welcome">Welcome to SHRI S R CONVENT SCHOOL!</p>
//       <p className="about-us-content">
//         At SHRI S R CONVENT SCHOOL, we are dedicated to fostering a nurturing and stimulating environment where students can thrive academically, socially, and emotionally. Our commitment to excellence in education is evident in everything we do, from our rigorous academic programs to our vibrant extracurricular activities.
//       </p>
//       <h2 className="about-us-subtitle">Our Mission</h2>
//       <p className="about-us-content">
//         Our mission at SHRI S R CONVENT SCHOOL is to empower each student to reach their full potential by providing a comprehensive education that promotes intellectual curiosity, critical thinking, and a love for lifelong learning. We strive to create a supportive community where respect, integrity, and collaboration are the foundations of our school culture.
//       </p>
//       <h2 className="about-us-subtitle">Our History</h2>
//       <p className="about-us-content">
//         Founded in [2012], SHRI S R CONVENT SCHOOL has a proud tradition of academic excellence and community involvement. Over the years, we have grown and evolved, continually adapting to meet the needs of our students and preparing them for the challenges of the future. Our alumni have gone on to achieve great success in various fields, and we take pride in their accomplishments.
//       </p>
//       <h2 className="about-us-subtitle">Academic Excellence</h2>
//       <p className="about-us-content">
//         At SHRI S R CONVENT SCHOOL, we offer a diverse curriculum designed to challenge and inspire our students. Our dedicated faculty are experts in their fields and are committed to providing personalized instruction that caters to the unique learning styles of each student. From our advanced placement courses to our hands-on science labs, we ensure that our students receive a well-rounded education that prepares them for higher education and beyond.
//       </p>
//       <h2 className="about-us-subtitle">Extracurricular Activities</h2>
//       <p className="about-us-content">
//         We believe that education extends beyond the classroom, which is why we offer a wide range of extracurricular activities to enhance our students' learning experiences. From sports teams and music ensembles to debate clubs and community service projects, there is something for everyone at SHRI S R CONVENT SCHOOL. These activities help our students develop essential life skills such as teamwork, leadership, and time management.
//       </p>
//       <h2 className="about-us-subtitle">Community and Values</h2>
//       <p className="about-us-content">
//         At the heart of SHRI S R CONVENT SCHOOL is a strong sense of community. We value diversity and inclusivity, and we work hard to create a welcoming environment where all students feel valued and respected. Our school values—respect, integrity, responsibility, and compassion—are woven into the fabric of our daily interactions and guide us in our pursuit of excellence.
//       </p>
//       <h2 className="about-us-subtitle">Join Us</h2>
//       <p className="about-us-content">
//         We invite you to explore all that SHRI S R CONVENT SCHOOL has to offer. Whether you are a prospective student, a parent, or a community member, we welcome you to become a part of our vibrant school community. Together, we can inspire the leaders of tomorrow.
//       </p>
//     </div>
//   );
// };

// export default About;


import React from 'react';
import './About.css';
import Mapcomponent from './Mapcomponent';

const About = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        <div className="about-left">
          <img
            src="\pic\DSC_0077.jpg"
            alt="School"
            className="about-image"
          />
          <h3>Shri S. R. Convent School</h3>
          <hr/>
          <h2>contact-info</h2>
          <div className="contact-info">
            <p><strong>Address:</strong> Vill. Theepuri, Shamshabad Road, Fatehabad (Agra)</p>
            <p><strong>Email:</strong> sr6018@gmail.com</p>
            <p><strong>Phone:</strong> +91 8909861356</p>
          </div>
          <Mapcomponent/>
        </div>
        <div className="about-right">
          <h2>About Us</h2>
          <p className="about-us-welcome">Welcome to SHRI S R CONVENT SCHOOL!</p>
      <p className="about-us-content">
        At SHRI S R CONVENT SCHOOL, we are dedicated to fostering a nurturing and stimulating 
environment where students can thrive academically, socially, and emotionally. Our commitment to 
excellence in education is evident in everything we do, from our rigorous academic programs to our
 vibrant extracurricular activities.
     </p>
          <h2>Our Aim</h2>
          <p className="about-us-content">
        Our mission at SHRI S R CONVENT SCHOOL is to empower each student to reach their full potential by providing a comprehensive education that promotes intellectual curiosity, critical thinking, and a love for lifelong learning. We strive to create a supportive community where respect, integrity, and collaboration are the foundations of our school culture.
       </p>
       <h2 className="about-us-subtitle">Our History</h2>
       <p className="about-us-content">
        Founded in [2012], SHRI S R CONVENT SCHOOL has a proud tradition of academic excellence and community involvement. Over the years, we have grown and evolved, continually adapting to meet the needs of our students and preparing them for the challenges of the future. Our alumni have gone on to achieve great success in various fields, and we take pride in their accomplishments.
     </p>
       <h2 className="about-us-subtitle">Academic Excellence</h2>
       <p className="about-us-content">
         At SHRI S R CONVENT SCHOOL, we offer a diverse curriculum designed to challenge and inspire our students. Our dedicated faculty are experts in their fields and are committed to providing personalized instruction that caters to the unique learning styles of each student. From our advanced placement courses to our hands-on science labs, we ensure that our students receive a well-rounded education that prepares them for higher education and beyond.
       </p>
       <h2 className="about-us-subtitle">Extracurricular Activities</h2>
       <p className="about-us-content">
       We believe that education extends beyond the classroom, which is why we offer a wide range of extracurricular activities to enhance our students' learning experiences. From sports teams and music ensembles to debate clubs and community service projects, there is something for everyone at SHRI S R CONVENT SCHOOL. These activities help our students develop essential life skills such as teamwork, leadership, and time management.
       </p>
       <h2 className="about-us-subtitle">Community and Values</h2>
       <p className="about-us-content">
         At the heart of SHRI S R CONVENT SCHOOL is a strong sense of community. We value diversity and inclusivity, and we work hard to create a welcoming environment where all students feel valued and respected. Our school values—respect, integrity, responsibility, and compassion—are woven into the fabric of our daily interactions and guide us in our pursuit of excellence.
       </p>
       <h2 className="about-us-subtitle">Join Us</h2>
       <p className="about-us-content">
         We invite you to explore all that SHRI S R CONVENT SCHOOL has to offer. Whether you are a prospective student, a parent, or a community member, we welcome you to become a part of our vibrant school community. Together, we can inspire the leaders of tomorrow.
       </p>
          <h2>Our Facilities</h2>
          <div className="facilities">
            <div className="facility">
              <div className="facility-icon"></div>
              <p>COMPUTER LAB</p>
              <span>We Provide Best Computer Lab</span>
            </div>
            <div className="facility">
              <div className="facility-icon"></div>
              <p>SCIENCE LAB</p>
              <span>Practical Science Lab</span>
            </div>
            <div className="facility">
              <div className="facility-icon"></div>
              <p>SPORTS</p>
              <span>Various Sport Activities in Campus</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

